  
  export const QuestionsCalling = [
    {
        id: 1,
        question: "1. What You Love (Passions & Interests)",
        area: "4"
    },
    {
        id: 2,
        question: "2. What You Are Good At (Skills & Strengths)",
        area: "4"
    },
    {
        id: 3,
        question: "3. What Industries Interest You?",
        area: "4"
    },
    {
        id: 4,
        question: "4. What Problems in the World Do You Care About Solving?",
        area: "4"
    },
    {
        id: 5,
        question: "5. What Personal Challenges or Transformations Have You Experienced?",
        area: "4"
    },
    {
        id: 6,
        question: "6. What Kind of Work Do You Enjoy?",
        area: "4"
    },
    {
        id: 7,
        question: "7. What Kind of Impact Do You Want to Have on People?",
        area: "4"
    },
  ];
  
  export const QuestionsStrategy = [
    {
        id: 8,
        question: "Where are you right now in your business journey? (For example: launching something new, growing an established business, or defending your market position)",
        area: "4"
    },
    {
        id: 9,
        question: "Have you made any sales yet? If so, tell me about them.",
        area: "4"
    },
    {
        id: 10,
        question: "What kind of lifestyle do you want your business to create for you? Think about your ideal work hours, location, family time, etc.",
        area: "4"
    },
    {
        id: 11,
        question: `What are your absolute "non-negotiables" in business? For example, "I won't work weekends" or "I need to maintain at least 30% profit margins."`,
        area: "4"
    },
    {
        id: 12,
        question: "What unique talents or strengths do you bring to your business that make you special?",
        area: "4"
    },
    {
        id: 13,
        question: `Let's set your revenue goals for the next 12 months:
                Minimum (I'd be satisfied with): $
                Target (I'm really aiming for): $
                Mind-blower (This would exceed my expectations): $
  `,
        area: "4"
    },
    {
        id: 14,
        question: "How many months will you actually be working toward these goals? (Most people should plan on 10-11 months, accounting for holidays, breaks, etc.)",
        area: "4"
    },
  ];
  
  export const QuestionsSpeaker = [
    {
        id: 15,
        question: "1. What topics am I deeply passionate about or highly knowledgeable in that I could talk about for hours?",
        area: "4"
    },
    {
        id: 16,
        question: "2. What unique skills or abilities do I have that could make me an engaging and impactful speaker? ",
        area: "4"
    },
    {
        id: 17,
        question: "3. Who would I love to present to?",
        area: "4"
    },
    {
        id: 18,
        question: "4. What is the key transformation or insight I want my audience to walk away with?",
        area: "4"
    },
    {
        id: 19,
        question: "5. What industries, societal shifts, or emerging trends align with my potential speaking topics?",
        area: "4"
    },
    {
        id: 20,
        question: "6. Do I prefer keynote speeches, TEDx-style talks, panels, workshops, interactive discussions, or another format?",
        area: "4",
    },
    {
        id: 21,
        question: "7. What personal experiences, stories, or challenges have I overcome that could add authenticity and relatability to my speeches?",
        area: "4"
    }


  ];


  export const QuestionsValueLadder = [
    {
        id: 22,
        question: "Which category best describes your business: B2C (business to consumer) or B2B (business to business)?",
        area: "4"
    },
    {
        id: 23,
        question: "What can you offer for free that would attract your ideal clients and start building your database?",
        area: "4"
    },
    {
        id: 24,
        question: "What can you create as your first paid offer (under $500 for B2C or under $5,000 for B2B) that would be an easy 'yes' for potential clients?",
        area: "4"
    },
    {
        id: 25,
        question: "What mid-ticket offer can you develop ($500-$2,000 for B2C or $5,000-$20,000 for B2B) that builds on your small offer?",
        area: "4"
    },
    {
        id: 26,
        question: "What will be your main offer ($2,000-$10,000 for B2C or $20,000-$100,000 for B2B) that delivers your core solution?",
        area: "4"
    },
    {
        id: 27,
        question: "What premium package can you create ($10,000+ for B2C or $100,000+ for B2B) for clients who want the highest level of service?",
        area: "4"
    },
    {
        id: 28,
        question: "Who is your target market and what are their high values that your offers should connect with?",
        area: "4"
    },
    {
        id: 29,
        question: "What system can you develop that makes your offers credible and demonstrates how clients will achieve results?",
        area: "4"
    },
    {
        id: 30,
        question: "What social proof can you include with your offers (testimonials, success stories, credentials)?",
        area: "4"
    },
    {
        id: 31,
        question: "What mid-ticket offer can you develop ($500-$2,000 for B2C or $5,000-$20,000 for B2B) that builds on your small offer?",
        area: "4"
    },
    {
        id: 32,
        question: "Are you structuring your offerings in the right order based on your business stage (one-on-one → group experiences → products)?",
        area: "4"
    },
    {
        id: 33,
        question: "What specific problem does each step in your customer journey solve completely?",
        area: "4"
    }
  
  ]

  export const QuestionValueProposition = [
    {
        id: 34,
        question: "Who is your specific audience? (e.g., new moms, small business owners, tech startups)",
        area: "4"
    },
    {
        id: 35,
        question: "What is the most significant challenge or problem your target market is struggling with?",
        area: "4"
    },
    {
        id: 36,
        question: "How would your clients describe this problem in their own words?",
        area: "4"
    },
    {
        id: 37,
        question: "What keywords would they use when searching for a solution?",
        area: "4"
    },
    {
        id: 38,
        question: "If you've experienced this problem yourself, how would you have described it?",
        area: "4"
    },
    {
        id: 39,
        question: "What specific solution do you provide to solve their problem?",
        area: "4"
    },
    {
        id: 40,
        question: "What is the big vision outcome (not the detailed process)?",
        area: "4"
    },
    {
        id: 41,
        question: "What is the end result or transformation you provide?",
        area: "4"
    },
    {
        id: 42,
        question: "What makes your approach different from competitors?",
        area: "4"
    },
    {
        id: 43,
        question: "Do you have unique values, certifications, expertise, or background that influences your work?",
        area: "4"
    },
    {
        id: 44,
        question: "Do you have unique access, processes, or connections that others don't?",
        area: "4"
    },
    {
        id: 45,
        question: "What makes your solution different or better than others?",
        area: "4"
    }

  ]

  export const QuestionsTargetMarket = [
    {
        "id": 46,
        "question": "Who are your past clients? (Or if starting: What groups of people are you particularly passionate about helping?)",
        "area" : "4"
    },
    {
        "id": 47,
        "question": "Among those clients, who do you most enjoy working with?",
        "area" : "4"
    },
    {
        "id": 48,
        "question": "Who gets the best results with your system/approach?",
        "area" : "4"
    },
    {
        "id": 49,
        "question": "Who do you currently have access to through your existing network?",
        "area" : "4"
    },
    {
        "id": 50,
        "question": "With whom do you naturally have rapport or connection?",
        "area" : "4"
    },
    {
        "id": 51,
        "question": "What is the age range of your ideal client?",
        "area" : "4"
    },
    {
        "id": 52,
        "question": "What is their gender (if relevant to your business)?",
        "area" : "4"
    },
    {
        "id": 53,
        "question": "What do they do professionally?",
        "area" : "4"
    },
    {
        "id": 54,
        "question": "Where do they hang out (online and offline)?",
        "area" : "4"
    },
    {
        "id": 55,
        "question": "What do they want in life?",
        "area" : "4"
    },
    {
        "id": 56,
        "question": "What are they experiencing in their daily life?",
        "area" : "4"
    },
    {
        "id": 57,
        "question": "What makes working with these clients \"flow easily\" for you?",
        "area" : "4"
    },
    {
        "id": 58,
        "question": "How would you describe the \"subculture\" your ideal client belongs to?",
        "area" : "4"
    },
    {
        "id": 59,
        "question": "What values are most important to your ideal client?",
        "area" : "4"
    },
    {
        "id": 60,
        "question": "Would your ideal client be willing to invest in solving their problem?",
        "area" : "4"
    },
    {
        "id": 61,
        "question": "What problem do people come to you to solve?",
        "area": "4"
    },
    {
        "id": 62,
        "question": "How would your clients describe their problem when they were first looking for a solution?",
        "area": "4"
    },
    {
        "id": 63,
        "question": "What keywords would they search for?",
        "area": "4"
    },
    {
        "id": 64,
        "question": "What do they ask their friends for help with?",
        "area": "4"
    },
    {
        "id": 65,
        "question": "What frustrates them the most about this problem?",
        "area": "4"
    },
    {
        "id": 66,
        "question": "If you've experienced this problem yourself, how would you have described it?",
        "area": "4"
    },
    {
        "id": 67,
        "question": "What have your ideal clients already tried to solve this problem?",
        "area": "4"
    },
    {
        "id": 68,
        "question": "How long have they typically been struggling with this problem?",
        "area": "4"
    },
    {
        "id": 69,
        "question": "What emotional impact does this problem have on them?",
        "area": "4"
    },
    {
        "id": 70,
        "question": "What specific language patterns do they use when describing their situation?",
        "area": "4"
    }
  ]

  export const QuestionsTrafficSources = [
    {"id": 71, "question": "What type of business do you have? (product, service, coaching, consulting, etc.)", "area": "h-30"},
    {"id": 72, "question": "What stage is your business in? (new, established, testing new offers)", "area": "h-30"},
    {"id": 73, "question": "Who is your target market/ideal client?", "area": "h-30"},
    {"id": 74, "question": "What are your business goals in the next 3-6 months?", "area": "h-30"},
    {"id": 75, "question": "What resources do you currently have? (time, budget, team)", "area": "h-30"},
    {"id": 76, "question": "What marketing skills do you or your team possess?", "area": "h-30"},
    {"id": 77, "question": "What is your monthly budget specifically for traffic generation activities?", "area": "h-30"},
    {"id": 78, "question": "What's your target cost per lead or customer acquisition cost?", "area": "h-30"},
    {"id": 79, "question": "Do you have an existing database? If yes, how large is it and how engaged are they?", "area": "h-30"},
    {"id": 90, "question": "Do you have a CRM system in place? If yes, which one?", "area": "h-30"},
    {"id": 11, "question": "What is your offer pricing structure?", "area": "h-30"},
    {"id": 82, "question": "What promotional assets do you currently have? (landing pages, free offers, etc.)", "area": "h-30"},
    {"id": 83, "question": "What is your sales conversion system? (webinars, calls, direct sales, etc.)", "area": "h-30"},
    {"id": 84, "question": "What metrics or KPIs do you currently track for your business?", "area": "h-30"},
    {"id": 85, "question": "Do you have any benchmarks or conversion rates from past marketing efforts?", "area": "h-30"},
    {"id": 86, "question": "What traffic sources have you tried before? What were the results?", "area": "h-30"},
    {"id": 87, "question": "Which of these traffic sources are you most interested in exploring and why? (Paid Media, SEO, Social Media & Podcasts, Speaking, Partnerships, PR, Offline Marketing, Affiliate Programs, Database Marketing)", "area": "h-30"},
    {"id": 88, "question": "Are there any traffic sources you're specifically not interested in pursuing? Why?", "area": "h-30"},
    {"id": 89, "question": "How comfortable are you with traffic strategies that require upfront investment versus pay-as-you-go models?", "area": "h-30"},
    {"id": 90, "question": "Do you have any existing partnerships or potential partnership opportunities?", "area": "h-30"},
    {"id": 91, "question": "What industries or business types do you believe have the same target audience as yours but offer non-competitive products/services?", "area": "h-30"},
    {"id": 92, "question": "What value can you offer potential partners beyond financial incentives?", "area": "h-30"},
    {"id": 93, "question": "Do you have experience managing partnership relationships?", "area": "h-30"},
    {"id": 94, "question": "How quickly do you need to see results from your traffic strategy?", "area": "h-30"},
    {"id": 95, "question": "Are there any seasonal considerations or specific dates you're targeting for your marketing efforts?", "area": "h-30"}
  ]
  

  export const QuestionsIrresistible = [
    {
        id: 96,
        question: "What transformation do your ideal clients desperately want to achieve?",
        area: "h-30"
    },
    {
        id: 97,
        question: "What specific pain points or challenges keep your ideal clients awake at night?",
        area: "h-30"
    },
    {
        id: 98,
        question: "How would you describe your clients' current situation and frustrations in their own words?",
        area: "h-30"
    },
    {
        id: 99,
        question: "What previous solutions have your clients tried that didn't deliver the results they wanted?",
        area: "h-30"
    },
    {
        id: 100,
        question: "What headline would capture the essence of your transformation in a compelling way?",
        area: "h-30"
    },
    {
        id: 101,
        question: "How would you articulate your core promise in one powerful statement?",
        area: "h-30"
    },
    {
        id: 102,
        question: "What unique methodology or framework do you use to deliver results?",
        area: "h-30"
    },
    {
        id: 103,
        question: "What specific steps does your solution include to take clients from their current state to desired outcome?",
        area: "h-30"
    },
    {
        id: 104,
        question: "What makes your approach different from what competitors offer?",
        area: "h-30"
    },
    {
        id: 105,
        question: "What core deliverables will clients receive as part of your offer?",
        area: "h-30"
    },
    {
        id: 106,
        question: "How will you support clients through the implementation process?",
        area: "h-30"
    },
    {
        id: 107,
        question: "What additional bonuses could you include that enhance the core value of your offer?",
        area: "h-30"
    },
    {
        id: 108,
        question: "What unexpected extras could you include that would surprise and delight clients?",
        area: "h-30"
    },
    {
        id: 109,
        question: "What specific results have your past clients achieved that you can share?",
        area: "h-30"
    },
    {
        id: 110,
        question: "What credentials or experience establish your authority in this area?",
        area: "h-30"
    },
    {
        id: 111,
        question: "What unique opportunity or exclusive access does your offer provide?",
        area: "h-30"
    },
    {
        id: 112,
        question: "How does your offer connect to the deeper values or priorities of your target market?",
        area: "h-30"
    },
    {
        id: 113,
        question: "What guarantee or assurance could you offer to remove purchasing anxiety?",
        area: "h-30"
    },
    {
        id: 114,
        question: "What objections do potential clients typically raise, and how will you address them?",
        area: "h-30"
    },
    {
        id: 115,
        question: "What is the actual monetary value of solving this problem for your clients?",
        area: "h-30"
    },
    {
        id: 116,
        question: "How will you present your pricing to emphasize value over cost?",
        area: "h-30"
    },
    {
        id: 117,
        question: "What payment options could you offer to make the decision easier?",
        area: "h-30"
    },
    {
        id: 118,
        question: "What happens immediately after someone says 'yes' to your offer?",
        area: "h-30"
    },
    {
        id: 119,
        question: "How will you make the onboarding process simple and welcoming?",
        area: "h-30"
    },
    {
        id: 120,
        question: "What timeframe can clients expect to see initial and long-term results?",
        area: "h-30"
    },
    {
        id : 121,
        question : "Who is your specific audience? (e.g., new moms, small business owners, tech startups)",
        area : "h-30"
    }

];


export const QuestionConsultingNiche = [
    {
        id: 122,
        question: "1. What industries, skills, or specialized knowledge do you have that you could offer consulting services in?",
        area: "h-30"
    },
    {
        id: 123,
        question: "2. What problems have you successfully solved for past employers, clients, or in your own career that could be valuable to others?",
        area: "h-30",
        
    },
    {
        id: 124,
        question: "3. What type of clients or businesses do you feel most drawn to help?",
        area: "h-30"
    },

    {
        id: 125,
        question: "4. What recurring challenges, inefficiencies, or bottlenecks do you see in your field that you can help others overcome?",
        area: "h-30"
    }, {
        id: 126,

        question: "5. What industry trends, emerging technologies, or market shifts align with your expertise and create opportunities for consulting?",
       
        area: "h-30"
    },
    {
        id: 127,

        question: "6. What type of consulting delivery or business model do you prefer?",
        area: "h-30",
    },
    {
        id: 128,
        question: "7. What kind of transformation or measurable results do you want to help your clients achieve? How do you want to be perceived in your consulting field?",
        area: "h-30"
    },
]



export const QuestionCoachingNiche = [
    {
        id: 129,
        title : "Passions & Personal Growth:",
        question: "1. What transformational experiences have I gone through that I would love to help others navigate?",
        desc: [
            "Think about moments where you experienced breakthroughs in mindset, relationships, confidence, self-worth, or leadership. These experiences often shape the kind of coach you naturally become.",
        ],
        area: "h-30"
    },

    {
        id: 130,
        title : "Ideal Audience You Want to Coach:",
        question: "2. Who do you feel most drawn to coach or support in their growth journey?",
        desc: [
            "Consider the type of people who resonate with your experiences or values. This could be entrepreneurs, professionals, couples, creatives, or any group whose challenges you deeply understand.",
        ],
        area: "h-30"
    },
    {
        id: 131,
        title : "Human Challenges You Want to Solve:",
        question: "3. What human challenges or struggles do you feel most passionate about helping people overcome?",
        desc: [
            "Think about emotional, mental, or relationship-based challenges like building resilience, improving communication, enhancing emotional intelligence, or healing past trauma.",
        ],
        area: "h-30"
    },
    {
        id: 132,
        title : "Your Professional & Informal Background:",
        question: "4. What formal or informal education, certifications, workshops, or personal learning have shaped your knowledge in areas related to coaching?",
        desc: [
            "Include any relevant training, books, or life experiences that have given you deep insights into personal growth, leadership, or mindset work.",
        ],
        area: "h-30"
    },
    {
        id: 133,
        title : "Your Natural Strengths in Coaching:",
        question: "5. What natural abilities, qualities, or skills do you have that would make you a great coach?",
        desc: [
            "Think about traits like deep listening, empathy, asking powerful questions, holding space for others, or guiding people through transformation.",
        ],
        area: "h-30"
    },
    {
        id: 134,
        title : "The Desired Impact You Want to Create:",
        question: "6. What specific outcomes do you want to help people achieve in their lives, careers, or relationships?",
        area: "h-30",
        desc: [
            "Consider the real transformations you want your clients to experience—whether it’s greater confidence, stronger relationships, leadership growth, or mindset shifts.",
        ],
    },
    {
        id: 135,
        title : "Key Mindset Shifts You Believe Are Essential:",
        question: "7. What mindset shifts do you think are essential for the transformation you want to help create?",
        desc: [
            "Identify the critical mental changes, such as moving from self-doubt to confidence, from blame to responsibility, or from fear to action, that will empower your clients.",
        ],
        area: "h-30"
    },

]


export const QuestionMasterbot = [
    {
        id: 136,
        title : "Conversation",
        question: "your whole conversation",
        area: "h-30"
    }
]


export const QuestionsWorkflow = [
        {
            id: 1,
            question: "What workflow would you like to automate or improve with AI?",
            area: "h-30"
        },
        {
            id: 2,
            question: "List the key steps in your workflow in order.",
            area: "h-30"
        },
        {
            id: 3,
            question: "Which tools or software do you currently use for each step?",
            area: "h-30"
        },
        {
            id: 4,
            question: "Which steps in the process involve manual data entry or repetitive tasks?",
            area: "h-30"
        },
        {
            id: 5,
            question: "Who are the key people involved in this process, and what are their specific roles?",
            area: "h-30"
        },
        {
            id: 6,
            question: "How do you typically receive the information or input needed to start this process?",
            area: "h-30"
        },
        {
            id: 7,
            question: "For each step, what key decisions do you need to make?",
            area: "h-30"
        },
        {
            id: 8,
            question: "Are there any points in the process where you have to wait for input or approval from others?",
            area: "h-30"
        },
        {
            id: 9,
            question: "What are the most common problems or bottlenecks you encounter in this workflow?",
            area: "h-30"
        },
        {
            id: 10,
            question: "How do you handle exceptions or unexpected issues that arise during this process?",
            area: "h-30"
        },
        {
            id: 11,
            question: "What is the final output of this workflow (e.g., report, invoice, approval)?",
            area: "h-30"
        },
        {
            id: 12,
            question: "How do you ensure the quality and accuracy of the output?",
            area: "h-30"
        },
        {
            id: 13,
            question: "Which steps in this process could be easily automated with the right tools?",
            area: "h-30"
        },
        {
            id: 14,
            question: "What data sources or databases do you need to access during this process?",
            area: "h-30"
        },
        {
            id: 15,
            question: "Are there any regulatory or compliance considerations involved in this process?",
            area: "h-30"
        },
        {
            id: 16,
            question: "How frequently do you perform this workflow? (Daily, weekly, monthly, etc.)",
            area: "h-30"
        },
        {
            id: 17,
            question: "How much time does each step in this workflow take on average?",
            area: "h-30"
        },
        {
            id: 18,
            question: "What is your monthly salary or cost to the company? (Approximate figures are fine‚ at this helps calculate potential savings from automation.)",
            area: "h-30"
        }
    ]




  
